import PropTypes from "prop-types";
import React from "react";
import reactT from "./../../components/reactT";

class FederatedSortMenu extends React.Component {

  constructor(props) {
    super(props);

    // Read sort and order values from the query string
    const urlSearchParams = new URLSearchParams(window.location.search);
    let sort = urlSearchParams.get("sort");
    let order = urlSearchParams.get("order");

    if (!sort || !this.props.sortFields.some((sf) => sf.field === sort)) {
      sort = "score"; // Set default sort value to "score"
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("sort", sort);
      const newUrl = window.location.pathname + "?" + searchParams.toString();
      window.history.replaceState({ path: newUrl }, "", newUrl);
    }

    if (!order || (order !== "asc" && order !== "desc")) {
      order = "desc"; // Set default order value to "desc"
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("order", order);
      const newUrl = window.location.pathname + "?" + searchParams.toString();
      window.history.replaceState({ path: newUrl }, "", newUrl);
    }

    this.state = {
      sort: sort,
      order: order,
      collapsed: window.innerWidth < 1199 ? true : false,
    };

    this.onSelect = this.onSelect.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    if (window.innerWidth < 1199) {
      this.setState({ collapsed: true });
    } else {
      this.setState({ collapsed: false });
    }
  }
  componentDidMount() {
    // Handle resize
    window.addEventListener("resize", this.handleResize);
  }

  onSelect(event) {
    const sortField = event.target.value;
    const sortOrder = event.target.getAttribute("order");
    const foundIdx = this.props.sortFields.indexOf(sortField);

    if (foundIdx < 0) {
      this.props.onChange(sortField, sortOrder);
    } else {
      this.props.onChange(null, null);
    }

    // Update the URL query string
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort", sortField);
    searchParams.set("order", sortOrder);
    const newUrl = window.location.pathname + "?" + searchParams.toString();
    window.history.pushState({ path: newUrl }, "", newUrl);

    this.setState({
      sort: sortField,
      order: sortOrder,
    });
  }


  render() {
    const { sortFields } = this.props;
    if (sortFields.length === 0) {
      return null;
    }

    return (
      <div className="block block-unhcr-search block-sort-by-search-block">
        <div className="accordion-filter" id="accordion">
          <div className="card-facet">
            <div className="card-header-facet d-flex align-items-center justify-content-between" id="headingSortBy">
            <div className="section-accordion-title d-flex justify-content-start justify-content-md-between align-items-center">
                  <span>
                    {reactT("Sort by")}
                    <span className="d-md-none font-weight-normal"><b>: </b>
                      {sortFields.find((sf) => sf.field === this.state.sort && sf.order === this.state.order)
                          .label}
                    </span>
                  </span>
                </div>
              <span
                className={
                  this.state.collapsed
                    ? "section-accordion-toggle collapsed"
                    : "section-accordion-toggle"
                }
                role="button"
                data-toggle="collapse"
                data-target="#collapseList"
                aria-expanded={this.state.collapsed}
                aria-controls="collapseOne"
                aria-label="Toggle collapse"
              >
              </span>
            </div>

            <div
              id="collapseList"
              className={this.state.collapsed ? "collapse" : "collapse show"}
              data-parent="#accordion"
            >
              <div className="card-body-facet">
                <div id="edit-sort" className="radio" onChange={this.onSelect}>
                  {sortFields.map((sortField, i) => (
                    <div
                      className="js-form-item js-form-type-radio radio form-check js-form-item-sort form-item-sort"
                      key={i}
                    >
                      <input
                        type="radio"
                        id={
                          "edit-sort-" + sortField.field + "-" + sortField.order
                        }
                        name="sort"
                        value={sortField.field}
                        order={sortField.order}
                        className="form-radio form-check-input"
                        defaultChecked={
                          this.state.sort === sortField.field && this.state.order === sortField.order ? true : false
                        }
                      />

                      <label
                        htmlFor={
                          "edit-sort-" + sortField.field + "-" + sortField.order
                        }
                        className="option"
                      >
                        {sortField.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FederatedSortMenu.propTypes = {
  bootstrapCss: PropTypes.bool,
  onChange: PropTypes.func,
  sortFields: PropTypes.array,
};

export default FederatedSortMenu;
